module.exports = __webpack_public_path__ + "img/mena-camel.0d76bca7.svg";